import { actionCreatorFactory } from 'typescript-fsa'
import { LogCount } from '../../types'

const actionCreator = actionCreatorFactory()

export const receiveLogCounts = actionCreator<LogCount[]>('receiveLogCounts')
export const receiveLogCount = actionCreator<LogCount>('receiveLogCount')
